/**
 * Generato automaticamente.
 * framework-cmp-domande
 */

export type EnumInfoDelegaTipo =
  (typeof EnumInfoDelegaTipo)[keyof typeof EnumInfoDelegaTipo];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumInfoDelegaTipo = {
  VISUALIZZAZIONE: 'VISUALIZZAZIONE',
  COMPILAZIONE: 'COMPILAZIONE',
  FIRMA: 'FIRMA',
} as const;
